import ReportHeader from '../components/layout/ReportHeader';
import ReportFooter from '../components/layout/ReportFooter';

export interface LayoutReportProps {
  children: React.ReactNode;
}

const ReportPage: React.FC<LayoutReportProps> = ({ children }) => (
  <>
    <ReportHeader />
    <main>{children}</main>
    <ReportFooter />
  </>
);
 
export default ReportPage;